import { Helmet } from 'react-helmet'

const isValidFont = (font) => {
  return font?.family && font?.url
}

export const Font = ({ themeFonts }) => {
  if (!Array.isArray(themeFonts)) return null

  const fonts = themeFonts.filter(isValidFont)

  if (!fonts.length) return null

  const css = fonts
    .map((f) => {
      if (f.format) {
        return `@font-face { font-family: "${f.family}"; src: url("${f.url}") format("${f.format}"); font-display: swap; }`
      }
      return `@import url('${f.url}');`
    })
    .join('\n')

  return (
    <Helmet>
      <style>{css}</style>
    </Helmet>
  )
}
